export default "__VITE_ASSET__c120cf68__"